export function getMetaValue(name) {
  var element = findElement(document.head, "meta[name=\"".concat(name, "\"]"));

  if (element) {
    return element.getAttribute("content");
  }
}
export function findElements(root, selector) {
  if (typeof root == "string") {
    selector = root;
    root = document;
  }

  var elements = root.querySelectorAll(selector);
  return toArray(elements);
}
export function findElement(root, selector) {
  if (typeof root == "string") {
    selector = root;
    root = document;
  }

  return root.querySelector(selector);
}
export function dispatchEvent(element, type) {
  var eventInit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var disabled = element.disabled;
  var bubbles = eventInit.bubbles,
      cancelable = eventInit.cancelable,
      detail = eventInit.detail;
  var event = document.createEvent("Event");
  event.initEvent(type, bubbles || true, cancelable || true);
  event.detail = detail || {};

  try {
    element.disabled = false;
    element.dispatchEvent(event);
  } finally {
    element.disabled = disabled;
  }

  return event;
}
export function toArray(value) {
  if (Array.isArray(value)) {
    return value;
  } else if (Array.from) {
    return Array.from(value);
  } else {
    return [].slice.call(value);
  }
}